import {
  mismatchValidator,
  Message,
  TextField
} from 'legos/text-field/base-field';
import { createElement, FC, useMemo, ReactNode } from 'react';

export interface ConfirmPasswordFieldProps {
  /** The name of this form field, unique in the current form context */
  name: string;
  /** Label node to display to the user for this field */
  label: ReactNode;
  /** The name of the new password field with which value should match */
  passwordField: string;
  /** Error to show when the value does not match with the password field  */
  errorPasswordMismatchMessage: ReactNode;
  /** Should display the password in plain text */
  showPlainText?: boolean;
}

export const ConfirmPasswordField: FC<ConfirmPasswordFieldProps> = ({
  name,
  label,
  showPlainText,
  passwordField,
  errorPasswordMismatchMessage
}) => {
  const mismatchError = 'mismatch';

  const validate = useMemo(
    () => mismatchValidator(passwordField, mismatchError),
    [passwordField]
  );

  return (
    <TextField
      type={showPlainText ? 'text' : 'password'}
      name={name}
      label={label}
      required
      validate={validate}
    >
      <Message
        touched
        error={mismatchError}
        children={errorPasswordMismatchMessage}
      />
    </TextField>
  );
};
